const reCurrency1 = /^\d+$/;
const reCurrency2 = /^\.\d$/;
const reCurrency3 = /^\.\d\d$/;
const reCurrency4 = /^\d+\.$/;
const reCurrency5 = /^\d+\.\d$/;
const reCurrency6 = /^\d+\.\d\d$/;
const daysInMonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const reCanZip = /^[ABCEGHJKLMNPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d$/i;
const reUsZip = /^\d{5}(-\d{4})?$/;
const reGlassDesc = /^[a-zA-Z]*$/;

function validateVcr1 (vcr_dorm, vcr_dord, vcr_dory, errorMessage, repoDate, daysDiff) {
  if (!isDate(vcr_dorm, vcr_dord, vcr_dory)) {
    errorMessage += 'Date of Recovery is invalid.\n';
    repoDate = null;
  } else {
    //If the date is ,more than 29 days old then give a warning first time only.
    let enteredDate = new Date(vcr_dory, vcr_dorm - 1, vcr_dord);
    if (repoDate == null || repoDate.getTime() !== enteredDate.getTime()) {
      repoDate = enteredDate;
      daysDiff = Math.ceil((new Date().getTime() - repoDate.getTime()) / (1000 * 60 * 60 * 24));
      console.log(parseInt(vcr_dorm) - 1);
      if (daysDiff > 29) errorMessage += 'Recovery date exceeds 29 days.  Please check and re-enter.\n';
      daysDiff = Math.ceil((repoDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
    }
  }

  return [errorMessage, daysDiff];
}

function validateVcr2(VcrFromData, errorMessage, vcr_preparedate_month, vcr_preparedate_day,
                      vcr_preparedate_year, daysDiff){
  let vcr_dorm = VcrFromData.rcvrDt.substring(5, 7);
  let vcr_dord = VcrFromData.rcvrDt.substring(8, 10);
  let vcr_dory = VcrFromData.rcvrDt.substring(0, 4);

  if (VcrFromData.prepByTx.isEmpty || VcrFromData.prepByTx === '') {
    errorMessage += "Enter a name in the 'Prepared By' field.\n";
  }
  if (!isDate(vcr_preparedate_month, vcr_preparedate_day, vcr_preparedate_year)) {
    errorMessage += 'Date of preparation is invalid.\n';
  } else {
    let enteredPrepDate = new Date(vcr_preparedate_year, vcr_preparedate_month - 1, vcr_preparedate_day);
    daysDiff = Math.ceil((enteredPrepDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
    if (daysDiff > 0) errorMessage += 'Prepared Date is in the future.\n';
    let enteredRecoveryDate = new Date(vcr_dory, vcr_dorm - 1, vcr_dord);
    if (enteredRecoveryDate.getTime() > enteredPrepDate.getTime())
      errorMessage += 'Recovery Date is after the Prepared Date.\n';
  }

  const mileageValue = VcrFromData.vehMlgeNb;

  if (!VcrFromData.vehMlgeNb && VcrFromData.vehMlgeNb !== 0) {
    errorMessage += 'Indicate mileage.\n';
  } else if (isNaN(mileageValue)) {
    errorMessage += 'Mileage must be numeric.\n';
  } else if (!Number.isInteger(mileageValue)) {
    errorMessage += 'Mileage must be a whole number (no decimals).\n';
  } else if (mileageValue < 0) {
    errorMessage += 'Mileage must be numeric and positive.\n';
  } else if (mileageValue > 999999) {
    errorMessage += 'Mileage must be less than 1000000.\n';
  }


  return errorMessage;
}

function validateVcr3(VcrFromData, errorMessage){
  if (VcrFromData.genCndtnCd.isEmpty || VcrFromData.genCndtnCd === '') {
    errorMessage += 'Indicate the general condition\n';
  }
  if (VcrFromData.mechCndtnCd.isEmpty || VcrFromData.mechCndtnCd === '') {
    errorMessage += 'Indicate the mechanical condition\n';
  }

  if (VcrFromData.keysInd.isEmpty || VcrFromData.keysInd === '') {
    errorMessage += 'Select yes or no for keys\n';
  }

  const condition = VcrFromData.glsCndtnCd;
  const description = VcrFromData.glsBrknDs;

  if (!condition || condition === '') {
    errorMessage += 'Indicate the glass condition\n';
  }else if (condition === 2 || condition === 3) {
    if (description === '') {
      const type = condition === 3 ? 'broken' : 'scratched';
      errorMessage += `Indicate location of ${type} glass.\n`;
    } else if (!reGlassDesc.test(description)) {
      errorMessage += 'Indicate Location contains invalid characters.\n';
    }
  }
  return errorMessage;
}

function validateVcr4(VcrFromData, errorMessage){
  if (VcrFromData.lfTireCndtnCd.isEmpty || VcrFromData.lfTireCndtnCd === '') {
    errorMessage += "Enter the condition of the 'Left Front' tire.\n";
  }
  if (VcrFromData.lrTireCndtnCd.isEmpty || VcrFromData.lrTireCndtnCd === '') {
    errorMessage += "Enter the condition of the 'Left Rear' tire.\n";
  }
  if (VcrFromData.rfTireCndtnCd.isEmpty || VcrFromData.rfTireCndtnCd === '') {
    errorMessage += "Enter the condition of the 'Right Front' tire.\n";
  }
  if (VcrFromData.rrTireCndtnCd.isEmpty || VcrFromData.rrTireCndtnCd === '') {
    errorMessage += "Enter the condition of the 'Right Rear' tire.\n";
  }
  if (VcrFromData.spTireCndtnCd.isEmpty || VcrFromData.spTireCndtnCd === '') {
    errorMessage += "Enter the condition of the 'Spare' tire.\n";
  }

  if (VcrFromData.intCndtnCd.isEmpty || VcrFromData.intCndtnCd === '') {
    errorMessage += 'Indicate the condition of the interior.\n';
  } else if (VcrFromData.intCndtnCd === 2) {
    if (VcrFromData.intExplDs.isEmpty || VcrFromData.intExplDs === '') {
      errorMessage += 'Explain the rough interior.\n';
    }
  } else {
    VcrFromData.intExplDs = 'NA';
  }

  return errorMessage;
}

function validateVcr5(VcrFromData, errorMessage) {
  if (VcrFromData.ovrlBodyCndtnCd === '' || VcrFromData.ovrlBodyCndtnCd.isEmpty) {
    errorMessage += "Enter the condition of the 'body'.\n";
  }
  if (VcrFromData.ovrlPntCndtnCd === '' || VcrFromData.ovrlPntCndtnCd.isEmpty) {
    errorMessage += "Enter the condition of the 'paint'.\n";
  }
  if (VcrFromData.ovrlBmprCndtnCd === '' || VcrFromData.ovrlBmprCndtnCd.isEmpty) {
    errorMessage += "Enter the condition of the 'bumpers'.\n";
  }

  if (VcrFromData.dmgEstAm.isEmpty || VcrFromData.dmgEstAm === '') {
    errorMessage += 'Enter an estimate of the damages.\n';
  } else if (!isCurrency(VcrFromData.dmgEstAm)) {
    errorMessage += 'Damage Estimate is not a valid currency format.\n';
  }

  if (VcrFromData.vehRcvrdFromNm === '' || VcrFromData.vehRcvrdFromNm.isEmpty) {
    errorMessage += 'Indicate who the vehicle was recovered from.\n';
  } else if (VcrFromData.vehRcvrdFromNm === 'OTHER') {
    if (VcrFromData.vehRcvOthrSpcfy.isEmpty || VcrFromData.vehRcvOthrSpcfy === '') {
      errorMessage += 'Specify who (Other) the vehicle was recovered from.\n';
    }
  }
  return errorMessage;
}

function validateVcr6(VcrFromData, errorMessage, countryCd) {
  if (VcrFromData.vehRcvrdAddrTx === '' || VcrFromData.vehRcvrdAddrTx.isEmpty) {
    errorMessage += 'Enter the recovered from address.\n';
  }
  if (VcrFromData.vehRcvrdAddrTx.length > 40) {
    errorMessage += "Recovered From Address can be only 40 characters.\n";
  }
  if (VcrFromData.vehRcvrdCityNm === '' || VcrFromData.vehRcvrdCityNm.isEmpty) {
    errorMessage += 'Enter the recovered from city.\n';
  }
  if (VcrFromData.vehRcvrdCityNm.length > 30) {
    errorMessage += 'Recovered from city can be only 30 characters.\n';
  }
  if (VcrFromData.vehRcvrdStAbbrCd === '' || VcrFromData.vehRcvrdStAbbrCd.isEmpty) {
    errorMessage += 'Enter the recovered from state.\n';
  }
  if (VcrFromData.vehRcvrdZipCd === '' || VcrFromData.vehRcvrdZipCd.isEmpty) {
    errorMessage += 'Enter the recovered from zip code.\n';
  } else if (!isZIPCode(VcrFromData.vehRcvrdZipCd, countryCd)) {
    if (countryCd === 'CAN') {
      errorMessage += 'Recovered from postal code must be a 6 character Canadian Postal Code.\n';
    } else {
      errorMessage += 'Recovered from zip code is invalid.\n';
    }
  }
  return errorMessage;
}

function validateVcr7(VcrFromData, errorMessage, countryCd) {
  const isEmpty = (val) => !val || val === '' || val.isEmpty; // unify check

  if (isEmpty(VcrFromData.cstRlsIn)) {
    errorMessage += 'Indicate if the release was signed by the customer.\n';
  } else if (VcrFromData.cstRlsIn === 'N') {
    if (isEmpty(VcrFromData.cstRlsDs)) {
      errorMessage += 'Explain why the release was not signed by the customer.\n';
    }

    if (isEmpty(VcrFromData.athNtfyIn)) {
      errorMessage += 'Indicate whether the proper authorities were notified.\n';
    } else if (VcrFromData.athNtfyIn === 'Y') {
      errorMessage = validateVcr10(VcrFromData, errorMessage,isEmpty,countryCd);
    } else if (isEmpty(VcrFromData.othCmtDs)) {
      errorMessage += "Please indicate, in 'Other Comments', why the proper authorities were not notified.\n";
    } else if (VcrFromData.othCmtDs.length > 255) {
      errorMessage += "'Other Comments' is too long, it can only be 255 characters.\n";
      errorMessage += 'Right now it is ' + VcrFromData.othCmtDs.length + ' characters.\n';
    }
  }

  return errorMessage;
}

function validateVcr8(VehLocData, errorMessage, countryCd) {
  const isEmpty = (val) => !val || val === '' || val.isEmpty;

  if (isEmpty(VehLocData.vehlocTypCd)) {
    errorMessage += 'Indicate the location of the vehicle.\n';
  } else if (VehLocData.vehlocTypCd === 'A') {
    if (isEmpty(VehLocData.auctDs)) {
      errorMessage += 'Select the auction name.\n';
    }
  } else {
    errorMessage = validateVcr9(VehLocData, errorMessage, isEmpty, countryCd);
  }

  return errorMessage;
}

function validateVcr9(VehLocData, errorMessage, isEmpty,countryCd) {
  if (isEmpty(VehLocData.vehLocNm)) {
    errorMessage += 'Vehicle Located At NAME is required.\n';
  }
  if (isEmpty(VehLocData.addrLine1Tx)) {
    errorMessage += 'Vehicle Located At ADDRESS LINE 1 is required.\n';
  }
   if (VehLocData.addrLine1Tx.length > 40) {
  errorMessage += "ADDRESS LINE1 can be only 40 characters.";
}
  if (isEmpty(VehLocData.cityNm)) {
    errorMessage += 'Vehicle Located At CITY is required.\n';
  }
  if (isEmpty(VehLocData.stAbbrCd)) {
    errorMessage += 'Vehicle Located At STATE is required.\n';
  }
  if (isEmpty(VehLocData.zipCd)) {
    errorMessage += 'Vehicle Located At ZIP CODE is required.\n';
  } else if (!isZIPCode(VehLocData.zipCd, countryCd)) {
    errorMessage += countryCd === 'CAN'
      ? 'A 6 character Vehicle Located at Canadian Postal Code is required.\n'
      : 'A 5 digit Vehicle Located At ZIP CODE is required.\n';
  }

  if (!checkPhoneArea(VehLocData.phnCityAreaCd) || !checkPhone(VehLocData.phnNb)) {
    errorMessage += 'Vehicle Located At Phone Number must be a 10 digit number.\n';
  }
  return errorMessage;
}

function validateVcr10(VcrFromData, errorMessage,isEmpty,countryCd) {
  if (isEmpty(VcrFromData.athNtfyNm)) {
    errorMessage += 'Enter the authorities notified name.\n';
  }
  if (isEmpty(VcrFromData.athNtfyAddrTx)) {
    errorMessage += 'Enter the authorities notified address.\n';
  }
  if (isEmpty(VcrFromData.athNtfyCityNm)) {
    errorMessage += 'Enter the authorities notified city.\n';
  }
  if (isEmpty(VcrFromData.athNtfyStAbbrCd)) {
    errorMessage += 'Enter the authorities notified state.\n';
  }
  if (isEmpty(VcrFromData.athNtfyZipCd)) {
    errorMessage += 'Enter the authorities notified zip code.\n';
  } else if (!isZIPCode(VcrFromData.athNtfyZipCd, countryCd)) {
    if (countryCd === 'CAN') {
      errorMessage += 'The authorities notified Postal Code must be a 6 character Canadian Postal Code.\n';
    } else {
      errorMessage += 'Authorities notified zip code is invalid.\n';
    }
  }
  return errorMessage;
}

export const validatevcr = (VcrFromData, VehLocData, countryCd) => {
  let errorMessage = '';
  let repoDate = new Date();
  let daysDiff = '';
  let msg = '';
  // Switched to a Calendar date-picker field but have to break it into components.
  let vcr_dorm = VcrFromData.rcvrDt.substring(5, 7);
  let vcr_dord = VcrFromData.rcvrDt.substring(8, 10);
  let vcr_dory = VcrFromData.rcvrDt.substring(0, 4);

  let vcr_preparedate_month = VcrFromData.prepDt.substring(5, 7);
  let vcr_preparedate_day = VcrFromData.prepDt.substring(8, 10);
  let vcr_preparedate_year = VcrFromData.prepDt.substring(0, 4);

  console.log(vcr_dorm + '     ' + vcr_dord + '   ' + vcr_dory);

  [errorMessage, daysDiff] = validateVcr1 (vcr_dorm, vcr_dord, vcr_dory, errorMessage, repoDate, daysDiff);
  errorMessage = validateVcr2(VcrFromData, errorMessage, vcr_preparedate_month, vcr_preparedate_day,
    vcr_preparedate_year, daysDiff);
  errorMessage = validateVcr3(VcrFromData, errorMessage);
  errorMessage = validateVcr4(VcrFromData, errorMessage);
  errorMessage = validateVcr5(VcrFromData, errorMessage);
  errorMessage = validateVcr6(VcrFromData, errorMessage, countryCd);
  errorMessage = validateVcr7(VcrFromData, errorMessage, countryCd);


  // this is put in case someone mistakenly fills in this area when it should be blank
  if (VcrFromData.othCmtDs.length > 255) {
    errorMessage += "'Other Comments' is too long, it can only be 255 characters";
    errorMessage += 'right now it is' + VcrFromData.othCmtDs.length + ' characters';
  }
  if (VcrFromData.msgEquipDs.length > 100) {
  errorMessage += "Remarks/Missing Equipment can be only 100 characters.";
}


  errorMessage = validateVcr8(VehLocData, errorMessage, countryCd);

  if (errorMessage !== '') {
    msg = 'The form was not submitted because the following corrections are required.\n';
    msg = msg + '***********************************\n\n';
    msg += errorMessage;
    return msg;
  } else {
    return null;
  }
};

function checkPhoneArea(phoneAreaField) {
  let bReturn = true;
  let rePhoneAreaNumbers = /^(\d)(\d)(\d)+$/;
  if (!(phoneAreaField.isEmpty || phoneAreaField === '')) {
    if (!rePhoneAreaNumbers.test(phoneAreaField)) {
      bReturn = false;
    }
  }
  return bReturn;
}

function checkPhone(phoneField) {
  let bReturn = true;
  let rePhoneNumbers = /^(\d)(\d)(\d)(\d)(\d)(\d)(\d)+$/;
  if (!(phoneField.isEmpty || phoneField === '')) {
    if (!rePhoneNumbers.test(phoneField)) {
      bReturn = false;
    }
  }
  return bReturn;
}
function isIntegerInRange(s, a, b) {
  let num = parseInt(s);
  return num >= a && num <= b;
}
function isCurrency(s) {
  return (
    reCurrency1.test(s) ||
    reCurrency2.test(s) ||
    reCurrency3.test(s) ||
    reCurrency4.test(s) ||
    reCurrency5.test(s) ||
    reCurrency6.test(s)
  );
}
function isZIPCode(s, countryCd) {
  if (countryCd === 'CAN') return reCanZip.test(s);
  else return reUsZip.test(s); //(isInteger(s) && ( (s.length === 5) || (s.length === 9) ) )
}

function isMonth(s) {
  let newS ;
  if (s[0] === '0') newS = s[1];
  else newS = s;
  return isIntegerInRange(newS, 1, 12);
}

function isDay(s) {
  let newS;
  if (s[0] === '0') newS = s[1];
  else newS = s;
  return isIntegerInRange(newS, 1, 31);
}

function isYear(s) {
  return s.length === 4;
}
function daysInFebruary(year) {
  return year % 4 === 0 && ((year % 100 !== 0) || year % 400 === 0) ? 29 : 28;
}
function stripLeadingZerosFromIntString(s) {
  if (s === '') {
    return s;
  }
  let newS = '';
  let strippingLeadingZeros = true;
  for (const char of s) {
    if (char !== '0' || !strippingLeadingZeros) {
      strippingLeadingZeros = false;
      newS += char;
    }
  }
  return newS;
}
function isDate(month, day, year) {
  let newMonth = stripLeadingZerosFromIntString(month);
  let newDay = stripLeadingZerosFromIntString(day);
  let newYear = stripLeadingZerosFromIntString(year);
  console.log(newMonth + '  ' + newDay + '  ' + newYear);
  if (newMonth.length === 0 || newDay.length === 0 || newYear.length === 0) {
    console.log('fails here!!');
    return false;
  }

  if (!(isMonth(newMonth) && isDay(newDay) && isYear(newYear))) {
    console.log('fails here!!');
    return false;
  }

  let intMonth = parseInt(newMonth);
  let intDay = parseInt(newDay);
  let intYear = parseInt(newYear);

  if (intDay > daysInMonth[intMonth - 1]) {
    console.log('fails here!!');
    return false;
  }

  if (intMonth === 2 && intDay > daysInFebruary(intYear)) {
    console.log('fails here!!');
    return false;
  }
  return true;
}